<template>
  <el-drawer
      title="题目列表"
      direction="rtl"
      @open="init"
      @close="closeDrawer"
      :visible.sync="visible"
      :with-header="false"
      :destroy-on-close="true"
      size="60%">
    <el-card class="box-card" shadow="never" style="border-bottom: none;height: 100vh;overflow-y: scroll">
      <div class="drawer-header">
        <h2 class="title">{{ value.subtitle }}</h2>
        <div class="toolbar text-align-reverse">
          <el-button type="primary" size="small" @click="toAddQue()" plain><i class="fa fa-plus"></i> 添加试题</el-button>
        </div>
      </div>
      <el-divider class="margin-bottom-15 margin-top-10"></el-divider>

      <el-table class="list-table" :data="questionList" border :stripe="true" style="width: 100%"
                :header-cell-style="{ background: '#eef1f6', color: '#606266' }">
        <el-table-column type="expand">
          <template slot-scope="scope">
            <table class="table table-bordered option-table">
              <tr>
                <th width="45" align="center">选项</th>
                <th>题目</th>
                <th width="80">分数</th>
                <th width="160">维度</th>
              </tr>
              <tr v-for="(opt,i) in scope.row.optionList" :key="i">
                <td style="text-align: center">{{ String.fromCharCode(65+i)}} </td>
                <td>{{ opt.name }}</td>
                <td>{{ opt.score }}</td>
                <td>{{ opt.degree }}</td>
              </tr>
            </table>
          </template>
        </el-table-column>
        <el-table-column label="序号" width="50">
          <template slot-scope="scope">
            <span>{{ scope.$index + 1 }}</span>
          </template>
        </el-table-column>
        <el-table-column label="题目" prop="title"></el-table-column>
        <el-table-column fixed="right" label="操作" width="130">
          <template slot-scope="scope">
            <el-button type="text" @click.prevent="toEditQue(scope.row)" size="small"><i class="fa fa-edit"></i> 编辑</el-button>
            <el-button type="text" @click.prevent="deleteQue(scope.row.id)" size="small"><i class="fa fa-trash"></i> 删除</el-button>
          </template>
        </el-table-column>
      </el-table>

      <!-- 添加编辑-->
      <question-save :visible="addQuestionVisible" :question="question" @done="saveFinish"></question-save>
    </el-card>
  </el-drawer>
</template>

<script>
import { fetchList, remove } from '@/api/manage/questions'
import QuestionSave from './QuestionSave'
import { handleConfirm } from '@utils/confirm'

export default {
  name: 'question-list',
  props: {
    value: {
      type: Object,
      required: true // 必传
    },
    visible:false
  },
  components: {
    QuestionSave
  },
  data: function() {
    return {
      addQuestionVisible:false,
      question: { },
      questionList: []
    }
  },
  methods: {
    init(){
      this.fetchData()
    },
    fetchData() {
      fetchList(this.value.id).then(resp => {
        this.questionList = resp.data.result
      })
    },
    toAddQue() {
      this.addQuestionVisible = true
      this.question = {paperId:this.value.id}
    },
    toEditQue(val) {
      this.addQuestionVisible = true
      this.question = val
    },
    closeDrawer(){
      this.$emit('done')
    },
    saveFinish(flag = false){
      this.addQuestionVisible = false
      if(flag){
        this.fetchData()
      }
    },
    deleteQue(val) {
      handleConfirm('此操作将删除该试题, 是否继续?').then(() => {
        remove(val).then(resp => {
          this.$message.success(resp.data.message)
          this.fetchData()
        })
      })
    }
  }

}
</script>
<style lang="scss" scoped>
.option-table{
  width: 98%;
  margin:5px auto;
  border-left: none;
  border-right: none;
  th{
    background-color: #f7f7f7;
  }
}
</style>
